export const getPropertyStatus = (item) =>
  String(
    item?.status ??
      item?.status_type ??
      item?.property_status ??
      item?.listing_status ??
      "",
  )
    .trim()
    .toLowerCase();

export const isSoldProperty = (item) => {
  const status = getPropertyStatus(item);
  if (["sold", "inactive", "closed", "completed"].includes(status)) return true;
  if (item?.is_sold === true || item?.isSold === true) return true;
  const soldDate =
    item?.sold_date ??
    item?.soldDate ??
    item?.date_sold ??
    item?.saleDate ??
    item?.sold_date_time;
  return Boolean(soldDate && String(soldDate).trim());
};

export const isForSaleProperty = (item) => {
  const status = getPropertyStatus(item);
  return status === "active" || status === "for sale";
};

export const isLeasedProperty = (item) => {
  const status = getPropertyStatus(item);
  return status === "leased" || status === "lease";
};

export const isForRentProperty = (item) => {
  const status = getPropertyStatus(item);
  return status === "rent" || status === "for rent";
};

export const matchesPropertyFilter = (item, filter) => {
  switch (filter) {
    case "Sold":
      return isSoldProperty(item);
    case "For sale":
      return isForSaleProperty(item);
    case "Leased":
      return isLeasedProperty(item);
    case "For rent":
      return isForRentProperty(item);
    default:
      return true;
  }
};

export const getListingDate = (item, filter) => {
  let raw;
  switch (filter) {
    case "Sold":
      raw =
        item?.sold_date ??
        item?.soldDate ??
        item?.date_sold ??
        item?.saleDate ??
        item?.sold_date_time ??
        item?.createdAt ??
        item?.updatedAt;
      break;
    case "Leased":
      raw =
        item?.leased_date ??
        item?.lease_date ??
        item?.sold_date ??
        item?.updatedAt ??
        item?.createdAt;
      break;
    case "For rent":
    case "For sale":
      raw =
        item?.listed_date ??
        item?.list_date ??
        item?.createdAt ??
        item?.updatedAt;
      break;
    default:
      raw =
        item?.sold_date ??
        item?.soldDate ??
        item?.leased_date ??
        item?.createdAt ??
        item?.updatedAt;
  }
  if (!raw) return null;
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const withinPropertyPeriod = (item, months, filter) => {
  if (!matchesPropertyFilter(item, filter)) return false;

  const d = getListingDate(item, filter);
  if (!d) return true;

  const cutoff = new Date();
  cutoff.setHours(0, 0, 0, 0);
  cutoff.setMonth(cutoff.getMonth() - months);
  return d >= cutoff;
};

export const getPropertyAgencyId = (item) =>
  item?.agency_id ??
  item?.agencyId ??
  item?.lead_agent?.agency_id ??
  item?.lead_agent?.agencyId ??
  item?.agency?._id ??
  item?.agency?.id ??
  null;

export const mergeAgencyProperties = (
  primary = [],
  extra = [],
  agencyId = null,
) => {
  const base = Array.isArray(primary) ? primary : [];
  const additional = Array.isArray(extra) ? extra : [];
  const merged = [...base];

  const existingIds = new Set(
    base.map((p) => p?._id ?? p?.id).filter(Boolean),
  );

  for (const item of additional) {
    const itemId = item?._id ?? item?.id;
    if (itemId && existingIds.has(itemId)) continue;

    if (agencyId != null && agencyId !== "") {
      const itemAgencyId = getPropertyAgencyId(item);
      if (itemAgencyId != null && String(itemAgencyId) !== String(agencyId)) {
        continue;
      }
    }

    if (itemId) existingIds.add(itemId);
    merged.push(item);
  }

  return merged;
};
